import { createApi, fetchBaseQuery, } from '@reduxjs/toolkit/query/react';
var baseQuery = fetchBaseQuery({
    baseUrl: "".concat(process.env.REACT_APP_API_URL),
    // credentials: 'include',
    prepareHeaders: function (headers) {
        var token = localStorage.getItem('token');
        if (token) {
            headers.set('authorization', "Bearer ".concat(token));
            // headers.set('AccessControlAllowCredentials', 'true');
        }
        return headers;
    },
});
export var api = createApi({
    reducerPath: 'baseApi',
    baseQuery: baseQuery,
    tagTypes: [
        'Tablets',
        'Users',
        'Restaurants',
        'Auth',
        'Menu',
        'Chats',
        'Payments',
        'Products',
        'CoinTransactions',
        'RestNetwork',
        'NewSchemes',
        'RecommendationLists',
        'Events',
        'PromoActions',
        'Cities',
        'ReferralStats',
        'ReferralSystemStats',
        'MyReferral',
        'UserReferral',
        'TopReferrers',
        'ReferralPeriodStats',
        'ReferralUsers',
        'ReferralStats',
        'ReferralSystemStats',
        'MyReferral',
        'UserReferral',
        'TopReferrers',
        'ReferralUsers',
        'ReferralCodes',
        'ReferralCode',
        'TogetherActivities',
        'Feed',
        'ProfileModeration',
        'ScreenAnalytics',
        'RestaurantStats',
        "UserPayments",
        "UserSpending",
        "UserBalance",
    ],
    endpoints: function (builder) {
        return ({
            login: builder.mutation({
                query: function (form) {
                    return ({
                        method: 'POST',
                        url: "/auth/login",
                        body: form,
                    });
                },
                invalidatesTags: ['Auth'],
            }),
            getProfile: builder.query({
                query: function () {
                    return ({
                        method: 'GET',
                        url: '/auth/profile',
                    });
                }
            }),
            logout: builder.mutation({
                query: function () {
                    return ({
                        method: 'POST',
                        url: "/auth/logout/",
                    });
                },
                invalidatesTags: ['Auth'],
            }),
        });
    },
});
export var useLoginMutation = api.useLoginMutation, useGetProfileQuery = api.useGetProfileQuery, useLazyGetProfileQuery = api.useLazyGetProfileQuery, useLogoutMutation = api.useLogoutMutation;
